export default {
    name: 'digsMixin',
    computed: {
        isDigsSubscribed() {
            if (this.glb.claimedHomes && this.glb.claimedHomes.length) {
                return this.glb.claimedHomes.map((v) => v.propertyId).indexOf(this.dpp.propertyId) !== -1;
            }
            return false;
        },
        goToDashboard() {
            if (this.isDigsSubscribed) {
                return this.glb.appUrl + 'homeowner/';
            }
        },
        isAskAgentTest() {
            if (this.getSplit('movoto-dpp-redesign-CW-2515')) {
                return false;
            }
            return this.getSplit('movoto-ask-agent-cta-CW-1968', 'on2') || this.getSplit('movoto-ask-agent-cta-CW-1968', 'on3');
        },
    },
    methods: {
        openDig() {
            this.$eventBus.$emit('eventbus-pop-dig');
        },
    }
}